import { createFileRoute, Outlet } from "@tanstack/react-router";

import { PurchaseStateContextProvider } from "@/contexts/PurchaseStateContext";
import { SearchDataMissingErrorBoundary } from "@/errors/SearchDataMissingErrorBoundary";
import { HotelDataProvider } from "@/features/hotels/contexts/HotelDataContext";
import { useHotelSearch } from "@/features/hotels/hooks/useHotelSearch";

export const Route = createFileRoute("/_authenticated/_hotels")({
  component: HotelsRoute,
});

function HotelsRoute() {
  return (
    <SearchDataMissingErrorBoundary>
      <RouteComponent />
    </SearchDataMissingErrorBoundary>
  );
}

function RouteComponent() {
  // this is only to initiate cache
  useHotelSearch();

  return (
    <HotelDataProvider>
      <PurchaseStateContextProvider>
        <Outlet />
      </PurchaseStateContextProvider>
    </HotelDataProvider>
  );
}
